import { State } from "../state/state";

export const totalPower = (outputs: State.Data): string => {
  let w = 0;
  outputs.forEach(ch => (w += Math.round(ch.v * ch.i)));
  return w.toFixed(1);
};
